import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import Button from '../../../Button';
import BuyCoreBrandedButton from '../../../Button/core/dsPresets/BuyCoreBrandedButton';
import { useVerification } from '../../../VerificationPopup/withVerification';
import { BiData } from '@wix/da-bi/pkg/events';
/** CTA button at the bottom of the AwardBadgeModal that can come in one of three types:
 *  - link-to-core: href to the ponies/buy-membership if the user doesn't have enough fragments and no core
 *  - close-modal: not enough fragments and already has core -> only choice wait for more, close modal for now
 *  - award-badge: has enough fragments so purchase it and award to recipient */ const ModalCTAButton = ({ className, mode, selectedBadge, recipient, disabled, awardSelectedBadge, requestClose })=>{
    const { t } = useTranslation();
    const { isVerificationNeeded, pushVerificationPopup } = useVerification();
    const awardSelectedBadgeIfVerified = useCallback(()=>{
        if (isVerificationNeeded) {
            return pushVerificationPopup('awardbadge');
        }
        awardSelectedBadge && awardSelectedBadge();
    }, [
        awardSelectedBadge,
        isVerificationNeeded,
        pushVerificationPopup
    ]);
    if (mode === 'link-to-core') {
        return /*#__PURE__*/ React.createElement(BuyCoreBrandedButton, {
            size: "large",
            biData: {
                referral_info: ReferralType.BADGE_GET_FRAGMENTS,
                typeid: recipient.typeId,
                itemid: recipient.itemId
            },
            withSaleSparkles: true
        }, t('coreBadge.awardBadgeModal.getCoreButton'));
    }
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: mode === 'close-modal' ? requestClose : awardSelectedBadgeIfVerified,
        className: className,
        disabled: disabled,
        biData: selectedBadge ? BiData({
            evid: 321,
            badge_type: selectedBadge.badge.name,
            badge_typeid: selectedBadge.badge.typeId,
            sectionname: recipient.typeId === 1 ? 'deviation' : 'comments',
            itemid: recipient.itemId,
            typeid: recipient.typeId
        }) : undefined
    }, mode === 'close-modal' ? t('coreBadge.awardBadgeModal.insufficientFragmentsButton') : t('coreBadge.awardBadgeModal.button'));
};
ModalCTAButton.displayName = 'ModalCTAButton';
export default ModalCTAButton;

//# sourceMappingURL=ModalCTAButton.js.map